import React, { Suspense } from "react";
import { Router, Route, Switch } from "react-router-dom";
import { hydrate, render } from "react-dom";
import TagManager from "react-gtm-module";

import Cookies from "js-cookie";
import ReactDOM from "react-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import * as serviceWorker from "./serviceWorker";
import history from "./history";

// Import Styles
import "./css/Base.scss";

// Import Components
import Modal from "./components/shared-ui/Modals/Modal";
import TermsModal from "./components/shared-ui/Modals/TermsModal";
import CookiesBar from "./components/CookiesBar";
// import ScrollToTop from "./ScrollToTop";

// ITP PAGES
import ITPHome from "./pages/ITP/ITPHome";
import WhatIsITP from "./pages/ITP/WhatIsITP";
import SignsAndSymptoms from "./pages/ITP/SignsAndSymptoms";
import TreatingITP from "./pages/ITP/TreatingITP";
import SettingGoals from "./pages/ITP/SettingGoals";
import TalkToYourDoctor from "./pages/ITP/TalkToYourDoctor";
import AboutDoptelet from "./pages/ITP/AboutDoptelet";
// import ConsideringDoptelet from "./pages/ITP/ConsideringDoptelet";
// import ManagingITP from "./pages/ITP/ManagingITP";
import SupportAndResources from "./pages/ITP/SupportAndResources";
import ThankYou from "./pages/ITP/ThankYou";
import ShareStoryThankYou from "./pages/ITP/ShareStoryThankYou";
import CLDHome from "./pages/CLD/CLDHome";
import NotFound from "./pages/NotFound";
import SmsTerms from "./pages/SmsTerms";
import Unsubscribe from "./pages/unsubscribe";
import FinancialAssistance from "./pages/ITP/FinancialAssistance";
// import VideoResources from "./pages/ITP/VideoResources";
import PatientResources from "./pages/ITP/PatientResources";
import PatientStories from "./pages/ITP/PatientStories";
import GetTips from "./pages/ITP/GetTips";
import HearFromARealPatient from "./pages/ITP/HearFromARealPatient";
import ShareYourStory from "./pages/ITP/ShareYourStory";
import FAQ from "./pages/ITP/FAQ";
import DrugLandingPage from "./pages/DrugLandingPage";

// PED page Components
import DopteletForChildren from "./pages/PED/DopteletForChildren";
import TakingDoptelet from "./pages/PED/TakingDoptelet";
import Resources from "./pages/PED/Resources";
import FinancialAssistanceInformation from "./pages/PED/FinancialAssistanceInformation";
import PEDPatientResources from "./pages/PED/PatientResources";
import PEDStayConnected from "./pages/PED/StayConnected";
import PEDStayConnectedThankYou from "./pages/PED/StayConnectedThankYou";
import AboutPersistentChronicITP from "./pages/PED/AboutPersistentChronicITP";

const tagManagerArgs = {
  gtmId: "GTM-5ZXSMJH",
};

function hideModalIfOpen(action) {
  // PUSH is for page change. POP is for hash change (i.e. clicking the terms modal);
  if (action === "PUSH") {
    const modals = document.querySelectorAll(".modal-modal");
    for (let modal of modals) {
      if (modal.classList.contains("fadeIn")) {
        modal.querySelector(".exitBtn").click();
      }
    }
  }
}

//this is to determine whether the recaptcha should show, componentDidUpdate and componenetDidMount weren't working for it
history.listen((location, action) => {
  // If the floating ISI happens to be exapanded and they navigate away make sure the page can scroll.
  document.querySelector("body").style.overflow = "visible";
  hideModalIfOpen(action);
  if (location.pathname !== "/cld/") {
    const cookieBar = document.getElementById("cookie-bar");
    cookieBar.dataset.isCld = -1;
  }
});

class App extends React.Component {
  constructor() {
    super();
    this.state = {
      cookieBarVisible: true,
    };
  }
  componentDidMount() {
    window.history.scrollRestoration = "manual";
    if (!Cookies.get("CookieConsent")) {
      this.setState({
        cookieBarVisible: true,
      });
      document.getElementById("cookie-bar").style.display = "block";
      document
        .querySelectorAll("div .home_hero .flex-wrapper .col .btn-info")
        .forEach((el) => {
          el.classList.add("translate");
        });
    } else {
      this.setState({
        cookieBarVisible: false,
      });
      document.getElementById("cookie-bar").style.display = "none";
      document
        .querySelectorAll("div .home_hero .flex-wrapper .col .btn-info")
        .forEach((el) => {
          el.classList.remove("translate");
        });
    }
  }

  render() {
    let cookieBarShowing = this.state.cookieBarVisible
      ? "show-cookie-bar"
      : "hide-cookie-bar";
    return (
      <div className={`App ${cookieBarShowing} `} id="OuterApp">
        <Modal />
        <TermsModal />
        <Router history={history}>
          <Suspense fallback={<div></div>}>
            <Switch>
              <Route exact path="/index.html" component={ITPHome} />
              <Route exact path="/" component={ITPHome} />
              <Route exact path="/home/" component={ITPHome} />
              <Route exact path="/what-is-itp/" component={WhatIsITP} />
              <Route
                exact
                path="/what-is-itp/itp-signs-and-symptoms/"
                component={SignsAndSymptoms}
              />
              <Route
                exact
                path="/what-is-itp/itp-diagnosis-and-treatment"
                component={TreatingITP}
              />
              <Route exact path="/setting-goals/" component={SettingGoals} />
              <Route
                exact
                path="/what-is-doptelet/"
                component={AboutDoptelet}
              />
              <Route
                exact
                path="/patient-stories/"
                component={PatientStories}
              />
              <Route
                exact
                path="/talk-to-your-doctor/"
                component={TalkToYourDoctor}
              />
              <Route
                exact
                path="/support-and-resources/"
                component={SupportAndResources}
              />
              <Route
                exact
                path="/support-and-resources/financial-assistance/"
                component={FinancialAssistance}
              />
              <Route
                exact
                path="/support-and-resources/living-with-itp/"
                component={GetTips}
              />
              <Route
                exact
                path="/support-and-resources/itp-patient-stories/"
                component={HearFromARealPatient}
              />
              <Route
                exact
                path="/support-and-resources/itp-patient-resources/"
                component={PatientResources}
              />
              <Route
                exact
                path="/support-and-resources/share-your-story/"
                component={ShareYourStory}
              />
              <Route exact path="/chronic-itp-faqs/" component={FAQ} />
              <Route
                exact
                path="/avatrombopag-tpo-ra/"
                component={DrugLandingPage}
              />
              <Route
                path="/themes/pdf/prescribing-information.pdf"
                component={() => {
                  window.location.replace(
                    "/themes/pdf/prescribing-information.pdf",
                  );
                  return null;
                }}
              />

              <Route exact path="/thank-you/" component={ThankYou} />
              <Route
                exact
                path="/recruit-thank-you/"
                component={ShareStoryThankYou}
              />
              <Route exact path="/cld/" component={CLDHome} />

              {/* PED pages */}
              <Route exact path="/pediatric-itp/what-is-doptelet-for-children/" component={DopteletForChildren} />
              <Route
                exact
                path="/pediatric-itp/taking-doptelet-for-children/"
                component={TakingDoptelet}
              />
              <Route exact path="/pediatric-itp/support-and-resources/itp-caregiver-resources/" component={Resources} />
              <Route
                exact
                path="/pediatric-itp/support-and-resources/caregiver-financial-assistance/"
                component={FinancialAssistanceInformation}
              />
              <Route
                exact
                path="/pediatric-itp/support-and-resources/itp-faqs/"
                component={PEDPatientResources}
              />
              <Route
                exact
                path="/pediatric-itp/support-and-resources/caring-for-child-with-itp/"
                component={PEDStayConnected}
              />
              <Route
                exact
                path="/pediatric-itp/caring-for-child-with-itp/thank-you/"
                component={PEDStayConnectedThankYou}
              />
              <Route
                exact
                path="/pediatric-itp/what-is-itp-in-children/"
                component={AboutPersistentChronicITP}
              />

              <Route
                path="/patient/copay-assistance"
                component={() => {
                  window.location.replace(
                    "https://www.activatethecard.com/8015/?src=patient",
                  );
                  return null;
                }}
              />
              <Route exact path="/unsubscribe/" component={Unsubscribe} />
              <Route exact path="/sms-terms/" component={SmsTerms} />
              <Route component={NotFound} />
            </Switch>
          </Suspense>
          <CookiesBar />
        </Router>
      </div>
    );
  }
}

if (window.navigator.userAgent !== "ReactSnap") {
  TagManager.initialize(tagManagerArgs);
}

ReactDOM.render(<App />, document.getElementById("root"));

// React-Snap to generate static html files.
const rootElement = document.getElementById("root");
if (rootElement.hasChildNodes()) {
  hydrate(<App />, rootElement);
} else {
  render(<App />, rootElement);
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
